// extracted by mini-css-extract-plugin
export default {"googleDriveIcon":"yGqyyN"};